module.exports = __webpack_public_path__ + "static/media/19.9c8ba45c.mp3";